import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const DeviceLogsCollection = GenericCollectionFactory(GENERIC_IDS.DEVICE_LOGS);